export default {
  SET_TRANSACTION(state, payload) {
    state.transaction = payload;
  },
};
